// types
import type { EventLocatorItem } from './sidebar.types';

// components
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { validateDate } from 'utils/validateDate';
import { DATE_FORMAT } from '../constants';

function SidebarItemEvent({ item: { title, date } }: Readonly<{ item: EventLocatorItem }>) {
  const createdDate = validateDate(new Date(date), DATE_FORMAT);

  return (
    <>
      <InnerHtml as="b" content={title} />
      {date && <InnerHtml as="div" content={createdDate ?? undefined} />}
    </>
  );
}

export default SidebarItemEvent;
